import {
  type OrchestratedOfferingListingDetails,
  type OrchestratedAuctionListingDetails,
  isOfferingListing,
} from '@b-stock/fe-core/bstock-next/queries'

import {
  Card,
  CardBody,
} from '@/buyer-portal/components/layouts/CardLayout/card/ui'

import { OfferingInfo } from './OfferingInfo'

export const OfferingInfoCard = ({
  listing,
}: {
  listing:
    | OrchestratedOfferingListingDetails
    | OrchestratedAuctionListingDetails
}) => {
  if (!isOfferingListing(listing) || listing.offering?.offerScope !== 'ITEM') {
    return null
  }

  return (
    <Card>
      <CardBody>
        <OfferingInfo
          itemsTotal={listing.itemsTotal}
          offerEndTime={listing.offering.offerEndTime}
          status={listing.status}
        />
      </CardBody>
    </Card>
  )
}
